import Splide from '@splidejs/splide';

const resourcesLoop = document.querySelector('#resources-loop');
const loadMoreButton = document.querySelector('#load-more-resources')

let busyInterval

let busyIndicator = (element) => {

    element.classList.add('busy-1')
    element.style.transition = 'all 1s'
    element.style.opacity = '0.25'

    busyInterval = window.setInterval(() => {

        if (element.classList.contains('busy-1')) {

            element.style.opacity = '0.75';

            element.classList.remove('busy-1')
            element.classList.add('busy-2')

        } else if (element.classList.contains('busy-2')) {

            element.style.opacity = '0.25'

            element.classList.remove('busy-2')
            element.classList.add('busy-1')

        }

    }, 1000)

}

let busyFinished = (element) => {

    element.classList.remove('busy-1', 'busy-2')
    element.style.opacity = '1'

    window.clearInterval(busyInterval)

}

let fetchResources = (onSuccess, onError) => {

    let paged = Number(resourcesLoop.getAttribute('data-paged'))

    let category = resourcesLoop.getAttribute('data-category')

    let search = resourcesLoop.getAttribute('data-search')

    let body = new FormData()

    body.append('action', 'ilo_resources_load_more')
    body.append('nonce',  resources_ajax_obj.nonce)
    body.append('paged',  paged)
    body.append('category', category)

    if (search.length) {
        body.append('search', search)
    }

    fetch(resources_ajax_obj.ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
        body: new URLSearchParams(body)
    }).then(response => response.text()).then((data) => {

        if (paged === 1) {
            resourcesLoop.innerHTML = data
        } else {
            resourcesLoop.innerHTML += data
        }

        init()

        onSuccess()

    }).catch(error => {

        console.log(error)

        onError()

    })

}

document.addEventListener('DOMContentLoaded', () => {

    let splides = document.querySelectorAll('.splide')

    splides.forEach(splide => {

        new Splide(splide, {
            pagination: false,
            rewind: true
        }).mount()

    })

    const resourcesCategoriesLinks = document.querySelectorAll('#resources-categories li a')

    resourcesCategoriesLinks.forEach((category) => {

        category.addEventListener('click', (e) => {

            e.preventDefault()

            const category = e.target.getAttribute('data-category')
            const listItemParent = e.target.closest('li')

            resourcesLoop.setAttribute('data-paged', '1')
            resourcesLoop.setAttribute('data-category', category)
            resourcesLoop.setAttribute('data-search', '')

            busyIndicator(resourcesLoop)

            fetchResources(() => {

                busyFinished(resourcesLoop)

                const listItemsSiblings = document.querySelectorAll('#resources-categories li')

                listItemsSiblings.forEach((listItemsSibling) => {
                    listItemsSibling.classList.remove(('active'))
                })

                listItemParent.classList.add('active')

                loadMoreButton.disabled = !!(resourcesLoop.querySelector('#resources-end'))

            }, () => {

                busyFinished(resourcesLoop)

            })

        })

    })

    const resourcesSearchForm = document.querySelector('#resources-search form')

    if (typeof(resourcesSearchForm) != 'undefined' && resourcesSearchForm != null) {
        resourcesSearchForm.addEventListener('submit', (e) => {

            e.preventDefault()

            const search = resourcesSearchForm.querySelector('#s').value

            resourcesLoop.setAttribute('data-paged', '1')
            resourcesLoop.setAttribute('data-category', '*')
            resourcesLoop.setAttribute('data-search', search)

            busyIndicator(resourcesLoop)

            fetchResources(() => {

                busyFinished(resourcesLoop)

                const listItemsSiblings = document.querySelectorAll('#resources-categories li')

                listItemsSiblings.forEach((listItemsSibling) => {
                    listItemsSibling.classList.remove(('active'))
                })

                const listItemAll = document.querySelector('#category-all').closest('li')

                listItemAll.classList.add('active')

                loadMoreButton.disabled = !!(resourcesLoop.querySelector('#resources-end'))

            }, () => {

                busyFinished(resourcesLoop)

            })

        });
    }

    if (typeof(loadMoreButton) != 'undefined' && loadMoreButton != null) {

        loadMoreButton.addEventListener('click', (e) => {

            e.preventDefault()

            loadMoreButton.disabled = true

            let placeholder = document.createElement('div')

            placeholder.setAttribute('id', 'placeholder')
            placeholder.style.backgroundColor = '#ccc';

            resourcesLoop.append(placeholder)

            busyIndicator(placeholder)

            let paged = Number(resourcesLoop.getAttribute('data-paged')) + 1

            resourcesLoop.setAttribute('data-paged', String(paged))

            fetchResources(() => {

                loadMoreButton.disabled = !!(resourcesLoop.querySelector('#resources-end'))

                resourcesLoop.querySelector('#placeholder').remove()

            }, () => {

                loadMoreButton.disabled = false

                resourcesLoop.querySelector('#placeholder').remove()

            })

        })
    }

})
